export var FolderableBulkActionType;
(function (FolderableBulkActionType) {
    FolderableBulkActionType["MOVE"] = "move";
})(FolderableBulkActionType || (FolderableBulkActionType = {}));
